import React from 'react';
import styled from 'styled-components';

import Cell from './common/Cell';
import DataCell from './common/DataCell';
import Row from './common/Row';
import MonitorField from './common/MonitorField';
import MonitorLabel from './common/MonitorLabel';
import ConfigControl from '../../../components/ConfigControl';
import { MonitorConfig } from '../../../helpers/constants';

export interface ICursorInfoAreaProps {
  currentConfig: string;
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export default function CursorInfoArea({
  currentConfig,
}: ICursorInfoAreaProps) {
  return (
    <>
      <ConfigControl elementFor={MonitorConfig.TACTICO} config={currentConfig}>
        <Container>
          <Row>
            <Cell>
              <MonitorLabel field="cursor-info-area-1" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="cursor-info-area-1" />
            </DataCell>
          </Row>
          <Row>
            <Cell>
              <MonitorLabel field="cursor-info-area-2" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="cursor-info-area-2" />
            </DataCell>
          </Row>
          <Row>
            <Cell>
              <MonitorLabel field="cursor-info-area-3" />
            </Cell>
            <DataCell width="55%">
              <MonitorField field="cursor-info-area-3" />
            </DataCell>
          </Row>
          <Row>
            <Cell></Cell>
            <DataCell width="55%"></DataCell>
          </Row>
        </Container>
      </ConfigControl>
      <ConfigControl elementFor={MonitorConfig.SISTEMA} config={currentConfig}>
        <Container>
          <Row>
            <Cell></Cell>
            <DataCell width="55%"></DataCell>
          </Row>
          <Row>
            <Cell></Cell>
            <DataCell width="55%"></DataCell>
          </Row>
          <Row>
            <Cell></Cell>
            <DataCell width="55%"></DataCell>
          </Row>
          <Row>
            <Cell></Cell>
            <DataCell width="55%"></DataCell>
          </Row>
        </Container>
      </ConfigControl>
    </>
  );
}
